import styled from 'styled-components';

export const IconContainer = styled.div`
  min-height: 30px;
  margin-top: 5px;
  img {
    margin-right: 10px;
  }
  @media print {
    float: right;
  }
`;
